import React, { Component } from 'react';

import OLMap from 'ol/map';
import VectorLayer from 'ol/layer/vector';
import VectorSource from 'ol/source/vector';
import OSM from 'ol/source/osm';
import proj from 'ol/proj';
import View from 'ol/view';
import extent from 'ol/extent';
import easing from 'ol/easing';
import styles from './map.scss';


class Map extends Component {
  constructor(props) {
    super(props);

    const { center, zoom } = this.props;

    this.map = new OLMap({
      view: new View({
        center,
        zoom,
        minZoom: 3
      }),
      // https://gis.stackexchange.com/questions/147008/allow-new-tiles-to-be-loaded-while-dragging-map
      loadTilesWhileInteracting: true,
      loadTilesWhileAnimating: true
    });

    if (props.onPointerMove) {
      this.map.on('pointermove', be => props.onPointerMove(be, this.map));
    }
    if (props.onMoveEnd) {
      this.map.on('moveend', be => props.onMoveEnd(be, this.map))
    }
    if (props.onFeatureHover) {
      this.map.on('pointermove', be => props.onFeatureHover(this.getFeaturesAtPixel(be)));
    }
  }

  getFeaturesAtPixel(be) {
    const { pixel } = be;
    const features = [];
    this.map.forEachFeatureAtPixel(pixel, (feature, layer) => {
      features.push(feature);
    });
    return features;
  }

  zoomToExtent(extent) {
    //http://openlayers.org/en/v4.0.1/apidoc/ol.View.html#fit
    this.map.getView().fit(extent, { duration: 2500, padding: [20, 20, 20, 20],  });
  }

  componentDidMount() {
    this.map.setTarget(this.refs.map)
  }

  componentWillUnmount() {
    this.map.setTarget(null);
    this.map = null;
  }

  componentWillReceiveProps(newProps) {
    if(newProps.center !== this.props.center || newProps.zoom !== this.props.zoom) {
      this.map.getView().setCenter(newProps.center);
      this.map.getView().setZoom(newProps.zoom);
    }
  }

  render(){
    return (
      <div ref="map">
        {
          React.Children.toArray(this.props.children).map(
            (child) => React.cloneElement(child, {
              mapInstance: this.map
            })
          )
        }
      </div>
    );
  }
}

//

export default Map;



// WEBPACK FOOTER //
// ./src/components/ol/Map.js